import React, { useState } from "react";
import PopupAHSF from "../../../Components/PopupAHSF";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TableAHSF from "../../../Components/TableDataProps";
import {
  DeleteItemFromArrayDataCheckBoks,
  SetArrayDataCheckBoks,
} from "../../../Redux/Reducers/Shared/CheckBox";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";

const ApplicationInfoSelected = (props) => {
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["tasksList"]
  );
  console.log(arrayDataCheckBoks, "arrayDataCheckBoks");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);

  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
    },
    {
      KeyName: "fullName",
      ShowStatus: true,
      NmaeColumn: " الاسم الكامل",
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: "الحقل",
    },
    {
      KeyName: "subjectName",
      ShowStatus: true,
      NmaeColumn: "الموضوع",
    },
  ];
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestsManagerBtns = [];

  // const OtherMainBtns = [
  //   {
  //     Click: async (e) => {
  //       console.log(e.target.value, "eeeeeeeeeeeeeeeeeeee");
  //     },
  //     className: "bi bi-trash",
  //     id: "deleteBtn",
  //     title: "",
  //     ShowStatus: true,
  //   },
  // ];
  const OtherMainBtns = [
    {
      Click: async (e) => {
        const idToRemove = e.currentTarget.value;
        console.log("Removing ID:", idToRemove);

        dispatch(
          DeleteItemFromArrayDataCheckBoks({
            KeyName: "tasksList",
            id: idToRemove,
            keyIdName: "applicationInformationId",
          })
        );

        dispatch(setRefreshTable({ tableId: "SelectedTable" }));

        console.log(" Deleted from Redux & localStorage:", idToRemove);
      },
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {},
    componentBody: <div></div>,
    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };
  console.log(arrayDataCheckBoks, "arrayDataCheckBoks");

  return (
    <>
      <TableAHSF
        tableId="SelectedTable"
        culomEdite={culomEdite}
        uniqueValue={"applicationInformationId"}
        valueButtonAction={"applicationInformationId"}
        dataRedux={arrayDataCheckBoks}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الطلبات"}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"taskId"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      />
    </>
  );
};

export default ApplicationInfoSelected;
